
import { AlertCircle, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

type GoogleMapsErrorProps = {
  errorMessage: string;
  onClose: () => void;
};

export function GoogleMapsError({ errorMessage, onClose }: GoogleMapsErrorProps) {
  return (
    <div className="text-destructive p-4 bg-destructive/10 rounded-md">
      <div className="flex items-start gap-2">
        <AlertCircle className="h-5 w-5 mt-0.5" />
        <div>
          <h3 className="font-medium mb-1">Google Maps Error</h3>
          <p>{errorMessage}</p>
          <div className="text-sm mt-2">
            <p className="font-medium">To fix this issue:</p>
            <ol className="list-decimal pl-5 mt-1 space-y-1">
              <li>Create a <code className="bg-muted px-1 rounded">.env</code> file in the project root</li>
              <li>Add your Google Maps API key: <code className="bg-muted px-1 rounded">VITE_GOOGLE_MAPS_API_KEY=your_api_key_here</code></li>
              <li>Restart your development server</li>
            </ol>
            <p className="mt-3 font-medium">Make sure your Google Maps API key has the following APIs enabled:</p>
            <ul className="list-disc pl-5 mt-1">
              <li>Maps JavaScript API</li>
              <li>Places API</li>
            </ul>
            <a 
              href="https://console.cloud.google.com/apis/dashboard" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:underline mt-2"
            >
              Go to Google Cloud Console <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
      <Button 
        variant="outline" 
        className="mt-4" 
        onClick={onClose}
      >
        Close
      </Button>
    </div>
  );
}
